"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var tslib_1 = require("tslib");
/* eslint-disable dot-notation */
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var controlled_1 = require("../form/controlled");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var config_context_1 = require("../_util/config-context");
var noop_1 = require("../_util/noop");
var key_map_1 = require("../_util/key-map");
exports.TextArea = forward_ref_with_statics_1.forwardRefWithStatics(function (props, ref) {
    var _a;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = controlled_1.useDefaultValue(props, ""), placeholder = _b.placeholder, disabled = _b.disabled, readonly = _b.readonly, size = _b.size, className = _b.className, style = _b.style, value = _b.value, onChange = _b.onChange, showCount = _b.showCount, _c = _b.onCompositionStart, onCompositionStart = _c === void 0 ? noop_1.noop : _c, _d = _b.onCompositionEnd, onCompositionEnd = _d === void 0 ? noop_1.noop : _d, _e = _b.onKeyPress, onKeyPress = _e === void 0 ? noop_1.noop : _e, _f = _b.onPressEnter, onPressEnter = _f === void 0 ? noop_1.noop : _f, restProps = tslib_1.__rest(_b, ["placeholder", "disabled", "readonly", "size", "className", "style", "value", "onChange", "showCount", "onCompositionStart", "onCompositionEnd", "onKeyPress", "onPressEnter"]);
    var composingRef = react_1.useRef(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _g = tslib_1.__read(react_1.useState(""), 2), composingRefValue = _g[0], setComposingValue = _g[1];
    var inputClassName = classnames_1.default(classPrefix + "-textarea", (_a = {},
        _a[className] = className,
        _a["size-" + (size === "full" ? size + "-width" : size)] = size,
        _a));
    var hasRows = restProps.rows;
    var inputProps = tslib_1.__assign({ placeholder: placeholder, className: inputClassName, readOnly: readonly, disabled: disabled, 
        // 受样式限制 rows 属性没有生效
        style: hasRows ? tslib_1.__assign({ height: "auto" }, (style || {})) : style, value: composingRef.current ? composingRefValue : value, onChange: function (event) {
            if (composingRef.current) {
                setComposingValue(event.target.value);
            }
            else {
                onChange(event.target.value, { event: event });
            }
        }, onCompositionStart: function (event) {
            composingRef.current = true;
            onCompositionStart(event);
        }, onCompositionEnd: function (event) {
            if (composingRef.current) {
                composingRef.current = false;
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue("");
            onCompositionEnd(event);
        }, onKeyPress: function (event) {
            if (event.key === key_map_1.KeyMap.Enter) {
                onPressEnter(event.currentTarget.value, event);
            }
            onKeyPress(event);
        } }, restProps);
    var component = react_1.default.createElement("textarea", tslib_1.__assign({ ref: ref }, inputProps));
    if (showCount) {
        var max = inputProps.maxLength;
        var len = value ? String(value).length : 0;
        return (react_1.default.createElement("div", { className: classPrefix + "-textarea-group", style: size === "full" ? { width: "100%" } : undefined },
            component,
            react_1.default.createElement("label", { className: classPrefix + "-textarea__label" }, max ? len + " / " + max : len)));
    }
    return component;
}, {
    /**
     * 在表单布局中，和 label 的默认对齐方式
     */
    defaultLabelAlign: "middle",
});
exports.TextArea.displayName = "TextArea";
//# sourceMappingURL=TextArea.js.map